import Sidebar from '../components/Sidebar';
import AdminSidebar from "../components/AdminSidebar";
import Header from '../components/Header';
import Footer from '../components/Footer';  // Add Footer here!
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  const role = localStorage.getItem("play")?.trim();

  const renderSidebar = () => {
    if (role === "Admin") {
      return <AdminSidebar />;
    }
    if (role === "employer") {
      return <Sidebar />;
    }
    return null; // jobSeeker or unknown
  };

  const showSidebar = role === "Admin" || role === "employer";

  return (
    <div className="main-layout">
      
       <Header />
       {renderSidebar()}

        
     
      <div className="content" 
           style={{
             marginLeft: showSidebar ? "250px" : "0px",
            }}
      >
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
